module.exports = __webpack_public_path__ + "img/confirma.4d4544cc.svg";